import type PurchasesDefault from 'react-native-purchases'
import type { PurchasesOffering, PurchasesPackage } from 'react-native-purchases'

export enum PackageIdentifier {
  Pro2Yearly = 'pro2_yearly',
  Ent2Monthly = 'ent2_monthly',
  Ent2Yearly = 'ent2_yearly',
}

export enum EntitlementIdentifier {
  Pro2 = 'pro2',
  Ent2 = 'ent2',
}

export type PurchaseResult = {
  success: boolean
  needsRestore?: boolean
}

export const initRevenueCat = async (_userId?: string) => {}

export const getOfferings = async (): Promise<PurchasesOffering | null> => null

export const checkEntitlement = async (): Promise<boolean> => false

export const purchasePackage = async (_packageToPurchase: PurchasesPackage): Promise<PurchaseResult> => ({
  success: false,
})

export const restorePurchases = async (): Promise<boolean> => false

export const getIsSandbox = async (): Promise<boolean> => false

export const requestRefund = async (): Promise<never> => {
  throw new Error('Not supported on this platform')
}

export const logOutRevenueCat = async () => {}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Purchases = null as unknown as typeof PurchasesDefault
